import {ISkeleton} from '../../interfaces/skeleton';
import {SkeletonTypeEnum} from '../../enums/skeleton';

export const CardListSkeleton: ISkeleton[] = [
  {
    multiple: false,
    type: SkeletonTypeEnum.TEXT,
    rows: 0,
    style: 'width: 100%',
  },
  {
    multiple: true,
    style: 'width: 100%; flex-wrap: nowrap;',
    items: [
      {
        type: SkeletonTypeEnum.INPUT,
        style: 'width: 72%; height: 30px;',
        classes: 'mr-xlg'
      },
      {
        type: SkeletonTypeEnum.INPUT,
        style: 'width: 28%; height: 30px;',
        classes: 'mr-xlg'
      },
      // {
      //   type: 'input',
      //   style: 'width: 25%; height: 30px;',
      //   classes: 'mr-xlg'
      // }
    ]
  },
  {
    multiple: true,
    style: 'width: 100%; flex-wrap: nowrap;',
    classes: 'mb-xlg mt-xlg',
    items: [
      {
        type: SkeletonTypeEnum.INPUT,
        style: 'width: 33%; height: 400px;',
        classes: 'mr-xlg'
      },
      {
        type: SkeletonTypeEnum.INPUT,
        style: 'width: 33%; height: 400px;',
        classes: 'mr-xlg'
      },
      {
        type: SkeletonTypeEnum.INPUT,
        style: 'width: 33%; height: 400px;',
        classes: 'mr-xlg'
      }
    ]
  },
  {
    multiple: true,
    style: 'width: 100%; flex-wrap: nowrap;',
    items: [
      {
        type: SkeletonTypeEnum.INPUT,
        style: 'width: 33%; height: 400px;',
        classes: 'mr-xlg'
      },
      {
        type: SkeletonTypeEnum.INPUT,
        style: 'width: 33%; height: 400px;',
        classes: 'mr-xlg'
      },
      {
        type: SkeletonTypeEnum.INPUT,
        style: 'width: 33%; height: 400px;',
        classes: 'mr-xlg'
      }
    ]
  }
];
